import {Navigate} from "react-router-dom";
import {PlatformLoader} from "@flexinet/ui-components";
import {PortalDashboard} from "../components/PortalDashboard";
import {useAuth} from "../../../hooks/useAuth";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions";
import {actionConstants} from "../../../config/rbac/actions";

export const IndexPage = () => {
    const {user} = useAuth();
    const {
        authorizing,
        allowedActions,
    } = useVerifiedPermissions();

    if (!user || authorizing) {
        return <PlatformLoader message="Loading dashboard...Please wait!"/>;
    }

    // Hiding the navbar entry is not access control: the menu gates on
    // GetDashboard, so the page must make the same decision for anyone who
    // types the URL. FNP-1410.
    if (!allowedActions.includes(actionConstants.GET_DASHBOARD)) {
        return <Navigate to="/"/>;
    }

    return <PortalDashboard/>;
};
